__turbopack_context__.v({
  "button": "GiveBlock-module-scss-module__P9QCRq__button",
  "buttonAccent": "GiveBlock-module-scss-module__P9QCRq__buttonAccent",
  "container": "GiveBlock-module-scss-module__P9QCRq__container",
});
